export const text = {
  title: 'Send Push Notification',
  selectUserType: 'Select User Type',
  selectProviders: 'Select',
  message: 'Enter message',
  sendNotification: 'Send Notification',
};
